import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconInfo(props) {
    return (
        <svg
            width={31}
            height={31}
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            d="M15.5 14.208a1.292 1.292 0 00-1.292 1.292v3.875a1.292 1.292 0 102.584 0V15.5a1.292 1.292 0 00-1.292-1.292zm0-3.875a1.291 1.291 0 100 2.583 1.291 1.291 0 000-2.583zm0-7.75A12.916 12.916 0 002.583 15.5a12.775 12.775 0 002.92 8.176L2.918 26.26a1.292 1.292 0 00-.271 1.407 1.292 1.292 0 001.227.75H15.5a12.917 12.917 0 100-25.834zm0 23.25H6.988l1.201-1.2a1.292 1.292 0 00.388-.918 1.292 1.292 0 00-.388-.904 10.334 10.334 0 117.31 3.022z"
            fill="#000"
            />
        </svg>
    )
}

export default SvgIconInfo;
